import { render, staticRenderFns } from "./SignatureTemplate6.vue?vue&type=template&id=e530e546&"
import script from "./SignatureTemplate6.vue?vue&type=script&lang=js&"
export * from "./SignatureTemplate6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports